import React from 'react';

import { SmButton } from '@smiles/smiles-react-design-system';

import { TModalContent } from '@/services/requests/Liferay/types';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';

import { TScreens } from '../..';

type TProps = {
  onClose: () => void;
  changeScreen: (newScreen: TScreens) => void;
  liferayContent: TModalContent;
};

export function Error({ onClose, changeScreen, liferayContent }: TProps) {
  const handleClickButton = () => {
    changeScreen('dashboard');
  };
  return (
    <div className="smls-b2c-modals__modal-content">
      <div className="smls-b2c-modals__button--close">
        <SmButton
          onClick={onClose}
          isPill
          isOutlined
          icon={<span className="material-icons">close</span>}
          data-testid="close-button"
        />
      </div>
      <div className="smls-b2c-modals__modal-content__error">
        <div className="smls-b2c-modals__modal-content__error__img-banner">
          <img src={liferayContent.title?.icon} alt="broken baggage icon" />
        </div>
        {liferayContent.title && (
          <div
            className="smls-b2c-modals__modal-content__error__title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: liferayContent.title.text,
            }}
          />
        )}
        {liferayContent.description && (
          <div
            className="smls-b2c-modals__modal-content__error__description"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: liferayContent.description.text,
            }}
          />
        )}
        <SmButton
          className="smls-b2c-modals__modal-content__error__try-again"
          loadingSize="large"
          text={clearHtmlTags(liferayContent.tryAgainBtn?.text || '')}
          variant="primary"
          disabled={false}
          onClick={handleClickButton}
        />
      </div>
    </div>
  );
}
